import Image from 'next/image';

type FeatureCardProps = {
  featuredImage: {
    url: string;
    alt: string;
  };
};

export default function FeatureCard({ featuredImage }: FeatureCardProps) {
  if (!featuredImage) return null;

  return (
    <div className="w-full max-w-5xl">
      <Image src={featuredImage.url} alt={featuredImage?.alt} layout="fill" />
    </div>
  );
}
